// Generated by apps/desktop/scripts/make-icons.mjs from fablekeep-mark.mjs — do not edit by hand.
/** The Fablekeep mark (tome-keep). `detail`: 'small' ≤ 40 px, 'mid' ≤ 96 px, 'full' above. */
export function FablekeepMark({
  className,
  detail = 'full',
}: {
  className?: string;
  detail?: 'small' | 'mid' | 'full';
}) {
  if (detail === 'small') return <MarkSmall className={className} />;
  if (detail === 'mid') return <MarkMid className={className} />;
  return <MarkFull className={className} />;
}

function MarkSmall({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 512 512" className={className} aria-hidden>
      <defs>
        <clipPath id="fkm-small-l">
          <rect x="0" y="0" width="256" height="512" />
        </clipPath>
        <clipPath id="fkm-small-in">
          <path d="M64 240A192 192 0 0 1 448 240L448 451.6Q448 464 435.6 464L76.4 464Q64 464 64 451.6Z" />
        </clipPath>
      </defs>
      <path
        d="M64 240A192 192 0 0 1 448 240L448 451.6Q448 464 435.6 464L76.4 464Q64 464 64 451.6Z"
        fill="#1A1511"
      />
      <g clipPath="url(#fkm-small-in)">
        <path
          d="M112 352L112 224L160 224L160 272L208 272L208 160L240 160L240 192L272 192L272 160L304 160L304 272L352 272L352 224L400 224L400 352Z"
          fill="#C9A35A"
        />
        <path
          d="M112 352L112 224L160 224L160 272L208 272L208 160L240 160L240 192L272 192L272 160L304 160L304 272L352 272L352 224L400 224L400 352Z"
          fill="#E8C77A"
          clipPath="url(#fkm-small-l)"
        />
        <path
          d="M80 336L432 336L432 400L80 400Z"
          fill="none"
          stroke="#1A1511"
          strokeWidth="32"
          strokeLinejoin="round"
        />
        <path d="M80 400L432 400L432 432L80 432Z" fill="#7A5C2A" />
        <path d="M80 400L432 400L432 432L80 432Z" fill="#9C7A3C" clipPath="url(#fkm-small-l)" />
        <path d="M80 336L432 336L432 400L80 400Z" fill="#E6CD92" />
        <path d="M80 336L432 336L432 400L80 400Z" fill="#FBEBBE" clipPath="url(#fkm-small-l)" />
        <path d="M240 336L240 288L272 288L272 336Z" fill="#16130F" />
        <path d="M240 80H272V96H288V128H272V144H240V128H224V96H240Z" fill="#FBEBBE" />
      </g>
      <path
        d="M64 240A192 192 0 0 1 448 240L448 451.6Q448 464 435.6 464L76.4 464Q64 464 64 451.6Z"
        fill="none"
        stroke="#C9A35A"
        strokeWidth="32"
        strokeLinejoin="round"
      />
      <path
        d="M64 240A192 192 0 0 1 448 240L448 451.6Q448 464 435.6 464L76.4 464Q64 464 64 451.6Z"
        fill="none"
        stroke="#EBCB82"
        strokeWidth="32"
        strokeLinejoin="round"
        clipPath="url(#fkm-small-l)"
      />
    </svg>
  );
}

function MarkMid({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 512 512" className={className} aria-hidden>
      <defs>
        <clipPath id="fkm-mid-l">
          <rect x="0" y="0" width="256" height="512" />
        </clipPath>
        <clipPath id="fkm-mid-in">
          <path d="M64 240A192 192 0 0 1 448 240L448 449.2Q448 464 433.2 464L78.8 464Q64 464 64 449.2Z" />
        </clipPath>
      </defs>
      <path
        d="M64 240A192 192 0 0 1 448 240L448 449.2Q448 464 433.2 464L78.8 464Q64 464 64 449.2Z"
        fill="#1A1511"
      />
      <g clipPath="url(#fkm-mid-in)">
        <path
          d="M120 360L120 220L136 220L136 248L148 248L148 220L164 220L164 268L200 268L200 148L240.73 148L240.73 178L271.27 178L271.27 148L312 148L312 268L348 268L348 220L364 220L364 248L376 248L376 220L392 220L392 360Z"
          fill="#C9A35A"
        />
        <path
          d="M120 360L120 220L136 220L136 248L148 248L148 220L164 220L164 268L200 268L200 148L240.73 148L240.73 178L271.27 178L271.27 148L312 148L312 268L348 268L348 220L364 220L364 248L376 248L376 220L392 220L392 360Z"
          fill="#E8C77A"
          clipPath="url(#fkm-mid-l)"
        />
        <path d="M242 232L242 206A14 14 0 0 1 270 206L270 232Z" fill="#16130F" />
        <path
          d="M100 338Q178 330 256 356Q334 330 412 338L412 400Q334 394 256 410Q178 394 100 400Z"
          fill="none"
          stroke="#1A1511"
          strokeWidth="20"
          strokeLinejoin="round"
        />
        <path
          d="M92 358Q174 350 256 376Q338 350 420 358L420 420Q338 414 256 430Q174 414 92 420Z"
          fill="#7A5C2A"
        />
        <path
          d="M92 358Q174 350 256 376Q338 350 420 358L420 420Q338 414 256 430Q174 414 92 420Z"
          fill="#9C7A3C"
          clipPath="url(#fkm-mid-l)"
        />
        <path
          d="M100 338Q178 330 256 356Q334 330 412 338L412 400Q334 394 256 410Q178 394 100 400Z"
          fill="#E6CD92"
        />
        <path
          d="M100 338Q178 330 256 356Q334 330 412 338L412 400Q334 394 256 410Q178 394 100 400Z"
          fill="#FBEBBE"
          clipPath="url(#fkm-mid-l)"
        />
        <path d="M228 356L228 328A28 28 0 0 1 284 328L284 356Z" fill="#16130F" />
        <path
          d="M256 66L264.16 91.84L290 100L264.16 108.16L256 134L247.84 108.16L222 100L247.84 91.84Z"
          fill="#FBEBBE"
        />
      </g>
      <path
        d="M64 240A192 192 0 0 1 448 240L448 449.2Q448 464 433.2 464L78.8 464Q64 464 64 449.2Z"
        fill="none"
        stroke="#C9A35A"
        strokeWidth="24"
        strokeLinejoin="round"
      />
      <path
        d="M64 240A192 192 0 0 1 448 240L448 449.2Q448 464 433.2 464L78.8 464Q64 464 64 449.2Z"
        fill="none"
        stroke="#EBCB82"
        strokeWidth="24"
        strokeLinejoin="round"
        clipPath="url(#fkm-mid-l)"
      />
    </svg>
  );
}

function MarkFull({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 512 512" className={className} aria-hidden>
      <defs>
        <clipPath id="fkm-full-l">
          <rect x="0" y="0" width="256" height="512" />
        </clipPath>
        <clipPath id="fkm-full-in">
          <path d="M61 240A195 195 0 0 1 451 240L451 450.4Q451 467 434.4 467L77.6 467Q61 467 61 450.4Z" />
        </clipPath>
      </defs>
      <path
        d="M61 240A195 195 0 0 1 451 240L451 450.4Q451 467 434.4 467L77.6 467Q61 467 61 450.4Z"
        fill="#1A1511"
      />
      <g clipPath="url(#fkm-full-in)">
        <path
          d="M124 360L124 214L140 214L140 236L152 236L152 214L168 214L168 262L204 262L204 144L227.11 144L227.11 168L244.44 168L244.44 144L267.56 144L267.56 168L284.89 168L284.89 144L308 144L308 262L344 262L344 214L360 214L360 236L372 236L372 214L388 214L388 360Z"
          fill="#C9A35A"
        />
        <path
          d="M124 360L124 214L140 214L140 236L152 236L152 214L168 214L168 262L204 262L204 144L227.11 144L227.11 168L244.44 168L244.44 144L267.56 144L267.56 168L284.89 168L284.89 144L308 144L308 262L344 262L344 214L360 214L360 236L372 236L372 214L388 214L388 360Z"
          fill="#E8C77A"
          clipPath="url(#fkm-full-l)"
        />
        <path d="M244 230L244 200A12 12 0 0 1 268 200L268 230Z" fill="#16130F" />
        <path
          d="M148 284L148 262A10 10 0 0 1 168 262L168 284ZM344 284L344 262A10 10 0 0 1 364 262L364 284Z"
          fill="#16130F"
        />
        <path
          d="M106 336Q181 328 256 354Q331 328 406 336L406 402Q331 396 256 412Q181 396 106 402Z"
          fill="none"
          stroke="#1A1511"
          strokeWidth="16"
          strokeLinejoin="round"
        />
        <path
          d="M98 352Q177 344 256 370Q335 344 414 352L414 418Q335 412 256 428Q177 412 98 418Z"
          fill="#7A5C2A"
        />
        <path
          d="M98 352Q177 344 256 370Q335 344 414 352L414 418Q335 412 256 428Q177 412 98 418Z"
          fill="#9C7A3C"
          clipPath="url(#fkm-full-l)"
        />
        <path
          d="M106 336Q181 328 256 354Q331 328 406 336L406 402Q331 396 256 412Q181 396 106 402Z"
          fill="#E6CD92"
        />
        <path
          d="M106 336Q181 328 256 354Q331 328 406 336L406 402Q331 396 256 412Q181 396 106 402Z"
          fill="#FBEBBE"
          clipPath="url(#fkm-full-l)"
        />
        <path d="M230 354L230 326A26 26 0 0 1 282 326L282 354Z" fill="#16130F" />
        <path
          d="M256 66L263.2 88.8L286 96L263.2 103.2L256 126L248.8 103.2L226 96L248.8 88.8Z"
          fill="#FBEBBE"
        />
      </g>
      <path
        d="M61 240A195 195 0 0 1 451 240L451 450.4Q451 467 434.4 467L77.6 467Q61 467 61 450.4Z"
        fill="none"
        stroke="#C9A35A"
        strokeWidth="18"
        strokeLinejoin="round"
      />
      <path
        d="M61 240A195 195 0 0 1 451 240L451 450.4Q451 467 434.4 467L77.6 467Q61 467 61 450.4Z"
        fill="none"
        stroke="#EBCB82"
        strokeWidth="18"
        strokeLinejoin="round"
        clipPath="url(#fkm-full-l)"
      />
      <path
        d="M86 240A170 170 0 0 1 426 240L426 438Q426 442 422 442L90 442Q86 442 86 438Z"
        fill="none"
        stroke="#C9A35A"
        strokeWidth="3"
        opacity=".55"
      />
    </svg>
  );
}
